import React from "react"
import PropTypes from "prop-types"
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded"
import {Box, Paper, Stack, Typography} from "@mui/material"
import ButtonWithIcon from "src/v2/components/Button/Button"
import DataGridScrollTable from "src/v2/components/Table/data-grid-scroll-table"

const ReportTable = ({title, rows, columns, loading, onRefresh}) => (
    <Paper sx={{p: 3, backgroundColor: "background.paper"}}>
        <Stack
            direction={{xs: "column", sm: "row"}}
            spacing={2}
            alignItems={{xs: "flex-start", sm: "center"}}
            justifyContent="space-between"
            sx={{mb: 2}}
        >
            <Typography variant="h3" color="common.white">{title}</Typography>
            {onRefresh && (
                <ButtonWithIcon icon={<RefreshRoundedIcon/>} onClick={onRefresh} disabled={loading}>
                    ATUALIZAR
                </ButtonWithIcon>
            )}
        </Stack>
        <Box sx={{height: 560, minHeight: 320, overflowX: "auto"}}>
            <DataGridScrollTable
                rows={rows}
                columns={columns}
                loading={loading}
                sx={{minWidth: columns.length > 5 ? 1000 : 600}}
            />
        </Box>
    </Paper>
)

ReportTable.propTypes = {
    title: PropTypes.string.isRequired,
    rows: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    onRefresh: PropTypes.func,
}

export default ReportTable
